var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTypeleft = function SvgTypeleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.21 12.5 2.792 2.793a.5.5 0 0 1-.707.707l-3.647-3.647a.5.5 0 0 1 0-.707L11.295 8a.498.498 0 0 1 .707 0 .5.5 0 0 1 0 .707L9.209 11.5h7.293a.5.5 0 0 1 0 1H9.209Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.002 12c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm10 9a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z",
    fill: "currentColor"
  })));
};
export { SvgTypeleft as ReactComponent };
export default __webpack_public_path__ + "584baafd593e89600e0224e0b2e03f39.svg";